import { useState } from 'react';
import { Workout } from '@/types/workout';
import { GenerateModeSelector, GenerateMode } from './GenerateModeSelector';
import { GenerateWorkoutFlow } from './GenerateWorkoutFlow';
import { ManualWorkoutWizard } from './ManualWorkoutWizard';

interface WorkoutCreatorProps {
  onComplete: (workout: Workout) => void;
  onCancel: () => void;
}

export function WorkoutCreator({ onComplete, onCancel }: WorkoutCreatorProps) {
  const [mode, setMode] = useState<GenerateMode | null>(null);

  const handleSelectMode = (selectedMode: GenerateMode) => {
    setMode(selectedMode);
  };

  const handleSwitchToAI = () => {
    setMode('ai');
  };

  const handleSwitchToManual = () => {
    setMode('manual');
  };

  const handleBackToModeSelect = () => {
    setMode(null);
  };

  // Show mode selector if no mode is selected
  if (!mode) {
    return (
      <GenerateModeSelector
        onSelectMode={handleSelectMode}
        onCancel={onCancel}
      />
    );
  }

  // Show AI flow
  if (mode === 'ai') {
    return (
      <GenerateWorkoutFlow
        onComplete={onComplete}
        onCancel={handleBackToModeSelect}
        onSwitchToManual={handleSwitchToManual}
      />
    );
  }

  // Show Manual flow
  return (
    <ManualWorkoutWizard
      onComplete={onComplete}
      onCancel={handleBackToModeSelect}
      onSwitchToAI={handleSwitchToAI}
    />
  );
}
